var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('iframe',{staticClass:"Map",staticStyle:{"border":"0"},attrs:{"src":this.locationUrl,"height":"450px","width":"100%","allowfullscreen":"","loading":"lazy"}})}
var staticRenderFns = []

export { render, staticRenderFns }